import { watch } from 'vue';

export function setupDirectives(app) {
  app.directive('anime', animeDir);
}

const _prefix = ' animated ';
const animeDir = {
  beforeMount(el, binding) {
    const { value, instance } = binding;
    const classes = Array.isArray(value) ? value : [value];
    let [enterClass, leaveClass] = classes;

    enterClass = enterClass && _prefix + enterClass;
    leaveClass = leaveClass && _prefix + leaveClass;

    watch(
      () => instance.$props.isActive,
      (nv) => {
        if (nv) {
          if (enterClass) el.className += enterClass;
        } else {
          el.className = el.className.replace(enterClass, '');
          if (leaveClass) el.className += leaveClass;
        }
      },
      {
        immediate: true,
      }
    );
  },
};
